import { UnitSystem, useUserPreferences } from "components/UserPreferences/UserPreferencesContext"

interface LengthProps {
  value: number
}

export const Length = ({ value }: LengthProps): React.JSX.Element => {
  const { locale, unitSystem } = useUserPreferences()
  return <>{formatLength(locale, unitSystem, value)}</>
}

export const LengthUnit = (): React.JSX.Element => {
  const { unitSystem } = useUserPreferences()
  return <>{getLengthUnit(unitSystem)}</>
}

function formatLength(locale: string, unitSystem: UnitSystem, value: number): string {
  if (unitSystem === UnitSystem.Imperial) {
    return new Intl.NumberFormat(locale, {
      unit: "mile",
      style: "unit",
      unitDisplay: "short",
      maximumFractionDigits: 2,
    }).format(value)
  }
  return new Intl.NumberFormat(locale, {
    unit: "kilometer",
    style: "unit",
    unitDisplay: "short",
    maximumFractionDigits: 2,
  }).format(value)
}

export function getLengthUnit(unitSystem: UnitSystem): string {
  if (unitSystem === UnitSystem.Imperial) {
    return "mi"
  }
  return "km"
}

const KILOMETER_TO_MILE = 0.621371

export const kilometersToMiles = (kilometers: number): number => {
  return kilometers * KILOMETER_TO_MILE
}
